import React from 'react';
import edit from '../Res/Icon/edit.png';
import del from '../Res/Icon/delete.png';

const CustomTemplateRow = ({ template, onView, onDelete }) => {
  return (
    <tr>
      <td>{template?.companyBox?.name || '-'}</td>
      <td>{template?.name || '-'}</td>
      <td>{template?.title || '-'}</td>
      <td>
        <div className="d-flex align-items-center justify-content-center">
          <img
            className="actions-icon"
            src={edit}
            alt="edit"
            onClick={() => onView(template)}
            style={{ cursor: 'pointer', marginRight: '10px' }}
          />

          <img
            className="actions-icon"
            src={del}
            alt="delete"
            onClick={() => onDelete(template)}
            style={{ cursor: 'pointer' }}
          />
        </div>
      </td>
    </tr>
  );
};

export default CustomTemplateRow;